import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from 'swiper/modules';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const Lightbox = ({ images, initialIndex = 0, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black/0 backdrop-blur-md flex items-center justify-center z-50">
      {/* Close button */}
      <button
        className="absolute top-4 right-6 z-50 text-white hover:text-gray-300 transition-colors bg-black/50 rounded-full w-10 h-10 flex items-center justify-center cursor-pointer"
        onClick={onClose}
        aria-label="Close"
      >
        <i className="fi fi-sr-cross text-base flex items-center justify-center"></i>
      </button>
      <div className="relative w-screen h-screen flex items-center justify-center">
        <Swiper
          slidesPerView={1}
          initialSlide={initialIndex}
          loop={images.length > 1}
          speed={500}
          navigation={images.length > 1 ? true : false}
          pagination={images.length > 1 ? { clickable: true, el: '.swiper-pagination' } : false}
          modules={[Pagination, Navigation]}
          className="w-full h-full portfolio-lightbox-swiper [&_.swiper-button-next]:bg-black/50 [&_.swiper-button-next]:rounded-full [&_.swiper-button-prev]:bg-black/50 [&_.swiper-button-prev]:rounded-full"
        >
          {images.map((image, idx) => (
            <SwiperSlide key={idx} className="flex items-center justify-center w-full h-full">
              <img
                className="object-contain w-full h-full max-h-screen max-w-screen"
                src={typeof image === 'string' ? image : image.src}
                alt={`lightbox-${idx}`}
              />
            </SwiperSlide>
          ))}
          {images.length > 1 && <div className="swiper-pagination !bottom-10 !left-1/2 !-translate-x-1/2 flex items-center justify-center gap-2"></div>}
        </Swiper>
      </div>
    </div>
  );
};

export default Lightbox; 